// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Expln_React_UseResizeObserver = require("./Expln_React_UseResizeObserver.bs.js");

function Expln_React_ContentWithStickyHeader(props) {
  var top = props.top;
  var top$1 = top !== undefined ? top : 0;
  var match = React.useState(function () {
        return top$1;
      });
  var setContentTop = match[1];
  var headerRef = React.useRef(null);
  Expln_React_UseResizeObserver.useClientSizeObserver(headerRef, (function (param, headerHeight) {
          Curry._1(setContentTop, (function (param) {
                  return top$1 + headerHeight | 0;
                }));
        }));
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  ref: Caml_option.some(headerRef),
                  style: {
                    background: "white",
                    position: "sticky",
                    top: "" + String(top$1) + "px",
                    zIndex: "1000"
                  }
                }, props.header), Curry._1(props.content, match[0]));
}

var make = Expln_React_ContentWithStickyHeader;

exports.make = make;
/* react Not a pure module */
